export function getCursor(isDragActive, canToggle, isReallyActive, contain) {
  let cursor = "default"
  if (isDragActive) {
    cursor = "grabbing"
  } else if (canToggle && isReallyActive) {
    cursor = contain ? "zoom-in" : "grab"
  }
  return cursor
}
